import SearchProductPage from './SearchProductPage';

export {
  SearchProductPage
};



// WEBPACK FOOTER //
// ./pages/search-product/index.js